import classes from "./profile-item.module.css";

type ProfileItemProps = {
	icon: string;
	title: string;
	values: string[];
};

export const ProfileItem = ({ icon, title, values }: ProfileItemProps) => (
	<div className={classes.item}>
		<div className={classes.left}>
			<div className={classes.title}>
				<img className={classes.icon} src={icon} alt={title} />
				<p>{title}</p>
			</div>
		</div>
		<div className={classes.right}>
			{values.map((value, index) => (
				<p className={classes.value} key={index}>
					{value}
				</p>
			))}
		</div>
	</div>
);
